export default __webpack_public_path__ + "static/media/planeSVG.404a0213.svg";